import React, { useEffect, useState } from "react";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Divider from "../ui/Divider";
import { listen } from "../hooks/Listener";
import { KBD } from "../utils/Keybindings";
import { VALIDATE } from "../utils/Validators";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { useGlobals } from "../hooks/Globals";
import TextButton from "../ui/TextButton";
import { kbdEvent } from "../utils/Utils";

export default function Help(props) {

    const { controller = "", route = "", callback = () => { }, component = <></>, width = 300 } = props;

    const actions = [
        { key: KBD.ESCAPE, action: () => { callback(false) } },
        { key: KBD.ENTER, action: () => { callback(false) } },
    ]

    useEffect(() => {
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ENTER]);
        return cleanup;
    }, [actions])


    return (
        <div style={{"width" : width + "px"}}>
            <div className="shim" />
            {component}
            <div className="shim" />
            <div className="shim" />
            <div onClick={() => kbdEvent(KBD.ENTER)} style={{ "textAlign": "center" }}><small> <TextButton>Close</TextButton></small></div>
        </div>
    )
}